import BOSS_UNAVAILABLE_CONSTANTS from './BossUnavailable.constants';

const initialState = {
  bossUnavailableProducts: [],
  bossUnavailableListId: '',
  convertedBossUnavailableList: [],
  removedBossUnavailableList: [],
  productListB4Delete: [],
  oosBossProductList: [],
};

function removeMultipleItem(state, { orderItems = [] }) {
  const filteredCartItems = state.bossUnavailableProducts?.filter(
    (item) => !orderItems.includes(item?.itemInfo?.itemId)
  );
  const productListB4Delete = state?.bossUnavailableProducts;
  return {
    ...state,
    productListB4Delete,
    bossUnavailableProducts: filteredCartItems,
  };
}

function addDeletedItemBack(state) {
  const productListB4Delete = state?.productListB4Delete;
  return {
    ...state,
    bossUnavailableProducts: productListB4Delete,
  };
}
const BossUnavailableReducer = (state = initialState, action) => {
  switch (action.type) {
    case BOSS_UNAVAILABLE_CONSTANTS.SET_BOSS_UNAVAILABLE_PRODUCTS:
      return { ...state, bossUnavailableProducts: action.payload };
    case BOSS_UNAVAILABLE_CONSTANTS.SET_BOSS_UNAVAILABLE_LIST_ID:
      return { ...state, bossUnavailableListId: action.payload };
    case BOSS_UNAVAILABLE_CONSTANTS.SET_CONVERTED_BOSS_UNAVAILABLE_ITEM:
      return { ...state, convertedBossUnavailableList: action.payload };
    case BOSS_UNAVAILABLE_CONSTANTS.SET_REMOVED_BOSS_UNAVAILABLE_ITEM:
      return { ...state, removedBossUnavailableList: action.payload };
    case BOSS_UNAVAILABLE_CONSTANTS.RESET_BOSS_UNAVAILABLE_STATE_REDUCER:
      return initialState;
    case BOSS_UNAVAILABLE_CONSTANTS.REMOVE_DELETED_ITEM:
      return removeMultipleItem(state, action.payload);
    case BOSS_UNAVAILABLE_CONSTANTS.ADD_DELETED_ITEM_ON_API_FAILURE:
      return addDeletedItemBack(state);
    case BOSS_UNAVAILABLE_CONSTANTS.SET_BOSS_UNAVAILABLE_PRODUCTS_IN_LIST:
      return { ...state, oosBossProductList: action.payload };
    default:
      return state;
  }
};

export default BossUnavailableReducer;
